/* eslint-disable no-console */
import LRU from 'lru-cache'
import { Context } from '@nuxt/types/app'
import { cacheAdapterEnhancer } from 'axios-extensions'
import { AxiosResponse, AxiosRequestConfig, AxiosError } from 'axios'
import { getCookie } from '~/utils/helpers'

const SIX_MINS = 1000 * 60 * 10

// @ts-ignore
export default function ({
  $axios,
  $sentry,
  ssrContext
}: Context) {
  /* @ts-ignore */
  // prettier-ignore
  const defaultCache = process.server ? ssrContext.$axCache : new LRU({ maxAge: SIX_MINS })

  const defaults = $axios.defaults
  // https://github.com/kuitos/axios-extensions
  // @ts-ignore
  defaults.adapter = cacheAdapterEnhancer(defaults.adapter, {
    enabledByDefault: process.env.NODE_ENV !== 'development',
    cacheFlag: 'useCache',
    defaultCache
  })
  $axios.defaults.timeout = 1000 * 15

  $axios.onResponse((response: AxiosResponse) => {
    if (response.data.data) {
      const res = response.data.data

      if (response.data.links) {
        res.links = response.data.links
      }

      if (response.data.pagination) {
        res.pagination = response.data.pagination
      }
      if (response.data.status && !res.status) {
        res.status = response.data.status
      }

      if (response.data.status) {
        res.status = response.data.status
      }

      return res
    }
  })

  $axios.onRequest((request: AxiosRequestConfig) => {
    if (process.client) {
      const token = getCookie('jwt_token')
      if (token) {
        request.headers.Authorization = `Bearer ${token}`
      }
    }

    return request
  })

  $axios.onError((error: AxiosError) => {
    if (process.server) {
      $sentry.captureException(error)
    }
  })
}
